/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Program.Performance.DomainComparison.vue?vue&type=template&id=b78ce0aa"
import script from "./Program.Performance.DomainComparison.vue?vue&type=script&lang=js"
export * from "./Program.Performance.DomainComparison.vue?vue&type=script&lang=js"
import style0 from "./Program.Performance.DomainComparison.vue?vue&type=style&index=0&id=b78ce0aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports